import { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

export const CuotaInfoBlock: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const [openSec, setOpenSec] = useState<'aporte' | 'cuota' | null>(null);
  const toggle = (s: 'aporte' | 'cuota') => setOpenSec(p => p === s ? null : s);

  return (
    <div className="rounded-xl border border-blue-200 bg-blue-50 p-4">
      <button type="button" onClick={() => setExpanded(e => !e)}
        className="w-full flex items-center gap-3 text-left">
        <HelpCircle className="w-6 h-6 text-blue-500 flex-shrink-0" />
        <span className="font-medium text-blue-800 text-base">¿Para qué sirven estos aportes?</span>
        <ChevronDown className={`w-5 h-5 text-blue-500 ml-auto transition-transform ${expanded ? 'rotate-180' : ''}`} />
      </button>

      {expanded && (
        <div className="mt-4 space-y-2">
          <div className="rounded-lg border border-blue-200 bg-white overflow-hidden">
            <button type="button" onClick={() => toggle('aporte')}
              className="w-full flex items-center justify-between px-4 py-3 text-left text-sm font-medium text-slate-700">
              Aporte mensual
              <ChevronDown className={`w-4 h-4 transition-transform ${openSec === 'aporte' ? 'rotate-180' : ''}`} />
            </button>
            {openSec === 'aporte' && (
              <p className="px-4 pb-4 text-sm text-slate-600">
                El aporte mensual cubre las necesidades materiales de tu Lumisial, tales como arriendo, luz,
                agua, otros gastos comunes, flores, mosto, artículos de limpieza, entre otros gastos
                esenciales para una buena mantención y funcionamiento.
              </p>
            )}
          </div>

          <div className="rounded-lg border border-blue-200 bg-white overflow-hidden">
            <button type="button" onClick={() => toggle('cuota')}
              className="w-full flex items-center justify-between px-4 py-3 text-left text-sm font-medium text-slate-700">
              Cuota iglesia
              <ChevronDown className={`w-4 h-4 transition-transform ${openSec === 'cuota' ? 'rotate-180' : ''}`} />
            </button>
            {openSec === 'cuota' && (
              <div className="px-4 pb-4 space-y-3">
                <p className="text-sm text-slate-600">
                  La cuota iglesia es el aporte que sostiene a la Iglesia Gnóstica a nivel nacional e
                  internacional. Es el motor económico del pueblo gnóstico: con ella apoyamos las distintas
                  áreas de la institución, su sostenimiento y crecimiento. Es un compromiso voluntario y a
                  conciencia, con una base mínima sugerida de $5.000.
                </p>
                <div>
                  <p className="text-sm font-medium text-slate-700 mb-1">¿En qué se ocupa?</p>
                  <ul className="list-disc pl-5 space-y-1 text-sm text-slate-600">
                    <li>Gastos administrativos para que la institución funcione legalmente (la Iglesia, la Asociación Cultural de Estudios Gnósticos, el Instituto de la Caridad Universal (ICU) y, progresivamente, otras ramas de la institución).</li>
                    <li>Difusión: campañas, página web y hosting.</li>
                    <li>Pasajes y visas de visitas, instructores y misioneros internacionales que vienen a entregar distintos cursos e instrucción en convivencias.</li>
                    <li>Apoyo al monasterio.</li>
                    <li>La cuota internacional de la Iglesia Federada, que sostiene proyectos y sedes indispensables a nivel mundial.</li>
                    <li>Otros gastos emergentes: misión nacional, emergencias en Lumisiales, implementación de elementos básicos, entre otros.</li>
                  </ul>
                </div>
                <div className="rounded-lg bg-blue-50 border border-blue-100 p-3">
                  <p className="font-medium text-blue-800 text-sm mb-1">¿Qué es el pago automático (PA)?</p>
                  <p className="text-sm text-slate-600">
                    Es un débito mensual seguro a través de Mercado Pago. Una vez configurado, la cuota
                    se descuenta automáticamente sin que tengas que recordar pagarlo cada mes.
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
